import { render } from "./addHotelSupplier.vue?vue&type=template&id=7386ccdc"
import script from "./addHotelSupplier.vue?vue&type=script&lang=js"
export * from "./addHotelSupplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__